module.exports = __webpack_public_path__ + "img/hero_en.1a94adc.jpg";